import type { ViewerPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS_VIEWER } from './defaults';
import type { HtmlPluginViewerConfig } from './types';
import { HTML_TYPE } from './types';
export { HTML_TYPE };
import { nodeViewRenderers } from './viewer/nodeViewRenderers';

export const pluginHtml: ViewerPluginCreator<HtmlPluginViewerConfig> = config => {
  return {
    config: { ...DEFAULTS_VIEWER, ...config },
    type: HTML_TYPE,
    nodeViewRenderers,
  };
};
